import { skipInitialFormValues } from "@/utils/formUtils";
import { URLQuery } from "@/utils/queryUtils";
import { validations } from "@/utils/validationUtils";
import { Button, Card, Col, Form, Row } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import AntIcon from "../../../../common/components/icons/AntIcon";
import { rowGutter } from "../../../../common/constants";
import InstitutionSelect from "../../../enumerations/components/form/InstitutionSelect";
import { InstitutionType } from "../../../institution/enums";
import { DEFAULT_FILTER_COVERAGE_LIMITS_QUERY_PARAMS } from "../../api";
import { CoverageLimitFilterPageRequest } from "../../types";

interface Props {
  searchParams: CoverageLimitFilterPageRequest;
  onCreateClick: () => void;
}

export const CoverageLimitFilterView = ({ searchParams, onCreateClick }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [form] = Form.useForm<CoverageLimitFilterPageRequest>();

  useEffect(() => {
    form.setFieldsValue(searchParams);
  }, [searchParams, form]);

  const onFilterSubmit = (values: CoverageLimitFilterPageRequest) => {
    navigate(
      {
        search: URLQuery.searchParamsToString({
          searchParams: {
            ...values,
            ...skipInitialFormValues(values, DEFAULT_FILTER_COVERAGE_LIMITS_QUERY_PARAMS),
            pageIndex: undefined,
          },
        }),
      },
      { replace: true },
    );
  };

  return (
    <Card
      className="card-box"
      title={<h2>{t("coverageLimit.titles.list")}</h2>}
      extra={
        <Button type="primary" icon={<AntIcon type="plus" />} onClick={onCreateClick}>
          {t("coverageLimit.actions.createLimit")}
        </Button>
      }
    >
      <Form form={form} onFinish={onFilterSubmit} layout="vertical" name="coverageLimitFilterForm">
        <Row gutter={rowGutter} justify="center">
          <Col flex="400px">
            <InstitutionSelect
              formItemProps={{
                name: "institutionIds",
                label: t("common.insuranceInstitutions"),
                rules: [validations.none],
              }}
              selectProps={{
                mode: "multiple",
                maxTagCount: "responsive",
                allowClear: true,
              }}
              optionsProps={{
                includeDeactivated: true,
                filterType: InstitutionType.INSURANCE_COMPANY,
              }}
            />
          </Col>

          <Col flex="110px" className="no-title-space">
            <Form.Item>
              <Button type="primary" htmlType="submit" icon={<AntIcon type="search" />}>
                {t("common.filter")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};
